module.exports = __webpack_public_path__ + "static/media/PeoTVGOLogo.00548174.PNG";